module.exports = __webpack_public_path__ + "static/media/logo_tspace_sourcing-1.bd0d45c9.png";